module.exports = {
  "hierarchy": {},
  "props": {
    "default": {}
  }
}